import { createContext, ReactNode, useContext, useState } from 'react';

type ModalContextType = {
  openModal: (id: string) => void;
  closeModal: () => void;
  isOpenModal: (id: string) => boolean;
  openModalId: string | null;
};

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider = ({ children }: { children: ReactNode }) => {
  const [openModalId, setOpenModalId] = useState<string | null>(null);

  const openModal = (id: string) => setOpenModalId(id);
  const closeModal = () => setOpenModalId(null);
  const isOpenModal = (id: string) => openModalId === id;

  return (
    <ModalContext.Provider value={{ openModal, closeModal, isOpenModal, openModalId }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModalContext = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModalContext must be used within ModalProvider');
  }
  return context;
};
